import request from './request.js';
import {requestbody} from './request.js'

export async function pageinfo(params = {

}) {
    return await requestbody('/batch/pageInfo', 'post', params)
}
export async function checkQc(params = {

}) {
    return await request('/batch/checkQc', 'post', params)
}
export async function startQc(params = {

}) {
    return await request('/batch/startQc', 'post', params)
}

export async function checkSj(params = {

}) {
    return await request('/batch/checkSj', 'post', params)
}
export async function startSj(params = {

}) {
    return await request('/batch/startSj', 'post', params)
}
export async function getTaskList(params = {

}) {
    return await request('/batch/getTaskList', 'post', params)
}
//税局状态同步
export async function checkShenBStatus(params = {

}) {
    return await request('batch/checkShenBStatus', 'post', params)
}
export async function initShenBStatus(params = {

}) {
    return await request('batch/initShenBStatus', 'post', params)
}
//起初数据下拉查询
export async function queryMustQcAndQsShuib(params = {

}) {
    return await request('/batch/queryMustQcAndQsShuib', 'get', params)
}

//批量清册
export async function batchStartQc(params = {

}) {
    return await request('/batch/batchStartQc', 'post', params)
}
//批量取数
export async function batchStartSj(params = {

}) {
    return await request('/batch/batchStartSj', 'post', params)
}
//批量发起申报状态更新任务
export async function batchInitShenBStatus(params = {

}) {
    return await request('batch/batchInitShenBStatus', 'post', params)
}
